export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-shape/src/identity.js
// module id = ZE+Q
// module chunks = 0